var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "47",
        height: "23",
        viewBox: "0 0 47 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M45.8212 12.1L39.2555 20.2C38.3639 21.3 37.2291 21.9 36.0132 21.9H1.72565C1.07719 21.9 0.752955 20.9 1.15825 20.3L7.80501 12.1C8.69665 11 9.83146 10.4 11.0473 10.4L45.1728 10.5C45.9023 10.5 46.2265 11.5 45.8212 12.1Z",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-miterlimit": "5",
          "stroke-linejoin": "bevel",
          "stroke-dasharray": "6 2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M45.8212 2.7L39.2555 10.8C38.3639 11.9 37.2291 12.5 36.0132 12.5H1.72565C1.07719 12.5 0.752955 11.5 1.15825 10.9L7.80501 2.7C8.69665 1.6 9.91252 1 11.1284 1L45.2538 1.1C45.9023 1.1 46.2265 2.1 45.8212 2.7Z",
          fill: "white",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-miterlimit": "10"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }